import { render, staticRenderFns } from "./auctioNotice.vue?vue&type=template&id=273ef304&scoped=true&"
import script from "./auctioNotice.vue?vue&type=script&lang=js&"
export * from "./auctioNotice.vue?vue&type=script&lang=js&"
import style0 from "./auctioNotice.vue?vue&type=style&index=0&id=273ef304&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273ef304",
  null
  
)

export default component.exports